const expressPackagemcQuestionsHash = (baseUrl) => {
  const url = [ baseUrl, "molson_coors_questions" ].join("/");
  return {
    thoughtBubble: `${url}/thought_bubble.png`
  };
};

export default expressPackagemcQuestionsHash;
